import { useState, useRef, useEffect, useCallback } from "react";

export function useTimer(initialDuration, onExpire, startImmediately = false) {
  const [timeLeft, setTimeLeft] = useState(initialDuration);
  const [isRunning, setIsRunning] = useState(false);
  const [hasEnded, setHasEnded] = useState(false);
  const intervalRef = useRef(null);

  // ici je gère l'avancement du timer et quand ça s'arrete
  const tick = useCallback(() => {
    setTimeLeft((prev) => {
      if (prev <= 1) {
        clearInterval(intervalRef.current);
        setIsRunning(false);
        setHasEnded(true);
        onExpire?.();
        return 0;
      }
      return prev - 1;
    });
  }, [onExpire]);

  const start = useCallback(() => {
    if (!isRunning && !hasEnded) {
      setIsRunning(true);
      intervalRef.current = setInterval(tick, 1000);
    }
  }, [isRunning, hasEnded, tick]);

  const pause = useCallback(() => {
    clearInterval(intervalRef.current);
    setIsRunning(false);
  }, []);

  const stop = useCallback(() => {
    clearInterval(intervalRef.current);
    setTimeLeft(0);
    setIsRunning(false);
    setHasEnded(true);
  }, []);

  const reset = useCallback(() => {
    clearInterval(intervalRef.current);
    setTimeLeft(initialDuration);
    setIsRunning(false);
    setHasEnded(false);
  }, [initialDuration]);


  // quand on détruit timer en gros
  useEffect(() => {
    return () => clearInterval(intervalRef.current);
  }, []);

  useEffect(() => {
    if (startImmediately) start();
  }, [startImmediately, start]);

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  return [
    timeLeft,
    minutes,
    seconds,
    isRunning,
    hasEnded,
    start,
    pause,
    stop,
    reset,
  ];
}
